module.exports = __webpack_public_path__ + "static/media/information_icon.8a907209.svg";